/**
 * EmployerRolesPage.jsx — Employer v1.1 Phase 0.6 Slice A
 * thin page wrapper for the Roles list. Replaces the legacy
 * EmployerRolesListPage.js route binding (legacy file untouched
 * on disk per strict additive governance).
 */
import RolesListPage from '@/components/employer/roles/RolesListPage';

export default function EmployerRolesPage() {
  return <RolesListPage />;
}
